import React from 'react';
import { useNeuroMessages, NeuroMessage } from '@ignitesales/neuro-application';

//Functions to get features, add-ons and disclosures of products

export const renderProductDisclosures = (productId) => {
  const { getMessage } = useNeuroMessages();
  const count = parseInt(getMessage(`${productId}.disclosure.count`) || "0");
  const disclosure = Array(count).fill(1).map((v, index) => {
    const msgIndex = index + 1;
    const id = `${productId}.disclosure.${msgIndex}`;
    return <NeuroMessage shouldHideIfNotFound={true} id={id} tagName="li"/>;
  });
  return disclosure.length ? <div className={"product__disclosure"}>
    <NeuroMessage shouldHideIfNotFound={true} id="product.disclosures.title" tagName="span" className="disclosuresTitle"/>
    <ol>{disclosure}</ol>
  </div> : null
};

const renderProduct50235Features = (feature) => {
  const features1 = feature.slice(0, 4);
  const feature2 = feature[4]
  const id = `${50235}.features.text`;

  return (<>
    <div className={"product__feature"}>
      <ul>{features1}</ul>
    </div>
    <NeuroMessage shouldHideIfNotFound={true} id={id} tagName="spam" />
    <div className={"product__feature"}>
      <ul>{feature2}</ul>
    </div>
  </>
  )
};

export const renderProductFeatures = (productId) => {
  const { getMessage } = useNeuroMessages();
  const count = parseInt(getMessage(`${productId}.features.count`) || "0");
  const feature = Array(count).fill(1).map((v, index) => {
    const msgIndex = index + 1;
    const id = `${productId}.features.${msgIndex}`;
    return <NeuroMessage shouldHideIfNotFound={true} id={id} tagName="li"/>;
  });

  if(productId === 50235) return renderProduct50235Features(feature);

  return feature.length ? <div className={"product__feature"}>
    <ul>{feature}</ul>
  </div> : null
};

export const renderProductAddOns = (product) => {
  const addOns = (product.addOns || []).map( (addOnProduct) => {
  
    return <div key={ addOnProduct.id } className={"addOns__product"}>
      <div className="addOns_info">
          <NeuroMessage id={`${addOnProduct.id}.name`} tagName="h1"/>
          <NeuroMessage id={`${addOnProduct.id}.description`} tagName="span"/>
      </div>
      <div className="addOns_disclosures">
          {renderProductDisclosures(addOnProduct.id)}
      </div>
    </div>;
  });

  return addOns.length ? <div className="product__addOns">
    <NeuroMessage id="products.addOns" tagName="span" className="disclosuresTitle"/>
    <div className="addOns">
      { addOns }
    </div>
  </div> : null;
};